import { render, staticRenderFns } from "./serviceApplicationList.vue?vue&type=template&id=68ed81f4&scoped=true&"
import script from "./serviceApplicationList.vue?vue&type=script&lang=js&"
export * from "./serviceApplicationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ed81f4",
  null
  
)

export default component.exports